import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Этнографический центр д. Кудричи';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <h3>Ethnographic center Kudrichi</h3>

                    <h4>А. Описание возможностей проекта</h4>
                    <p>А1 Название проекта: <strong>Создание в д. Кудричи Пинского района этнографического центра</strong></p>
                    <p>(а) Краткое название: Этнографический центр д. Кудричи</p>
                    <p>(b) Полное название: Этнографический центр д. Кудричи Пинского района</p>
                    <p>(c) Краткое описание (аннотация). Деревня расположена па берегу р. Ясельда, в 20 км от г. Пинска. Крытые камышовые хаты с сенями и «каморами». Колодцы оплетенные ивовыми прутьями, «стенки» для хранения продуктов. Белые и черные аисты, серые цапли и другие гнездящиеся на Полесье птицы.</p>
                    <p>А2 Состояние проекта: прединвестиционная стадия.</p>
                    <p>А3 Участвующие организации и их роль (контактные лица, телефон, факс, е-mail, страница в Интернет</p>
                    <ol>
                        <li>Пинский районный исполнительный комитет (общее руководство, инициатор проекта). ООО «Роза ветров» (прием туристов) Дурнопейко Е.М, тел. 35 07 09, факс 0165324904.</li>
                    </ol>
                    <p>А4 Описание проекта (подходы, задачи, компоненты, результаты, этапы, сроки, общее финансирование, преимущества, влияние на переходные процессы в экономике и т.д.)</p>
                    <p>задача привлечь туристов, результат доходы от туристической деятельности. Общее финансирование 300 млн. рублей.</p>
                    <p>А5 Предпосылки (история, общая программа, взаимосвязанные или схожие проекты): Приоритет в развитии въездного туризма, налоговые льготы</p>
                    <p>А6 Краткое описание влияния на окружающую среду: экологически безопасен.</p>
                    <p>А8 Срок реализации и окупаемости проекта (лет): Срок реализации проекта: 3 года. Срок окупаемости: 5 лет</p>
                    <p>А9 Отраслевая принадлежность проекта: туризм</p>

                    <h4>В. Статьи капитальных затрат (суммарные инвестиции, необходимые для реализации проекта):</h4>
                    <p>В1 Физические компоненты проекта (оборудование, работы, услуги и др. необходимые для реализации проекта): Основные средства (приобретение материалов, строительные работы, проектные работы)</p>
                    <p>B2 Капиталовложения (стоимость): 30 тыс. рублей</p>
                    <p>В4 Стоимость проекта: 30 тыс. рублей</p>
                    <p>Итого (должна равняться сумме С2+D4)</p>

                    <h4>С. Капитал по источнику происхождения, имеющейся в наличии инициаторов проекта (собственников, соучастников, спонсоров и т.п.)</h4>
                    <p>долевое Участие</p>

                    <h4>D. Требуемые инвестиции, недостающие средства</h4>
                    <p>-</p>

                    <h4>Е. Спрос (потребители) и доходы</h4>
                    <p>-</p>

                    <h4>F. Операционные и эксплуатационные расходы</h4>
                    <p>-</p>

                    <h4>G. Чистый доход</h4>
                    <p>-</p>

                    <h4>Н. Источник информации о проекте</h4>
                    <p>Н1 Форма заполнения (кем, Ф.И.О., должность): Кургуп Вячеслав Иванович, начальник отдела по физической культуре, спорту и туризму Пинского райисполкома</p>
                    <p>Н2 Организация (наименование и адрес): Пинский райисполком</p>
                    <p>Н3 Тел. / факс / Е- mail: Пинский райисполком, тел. 35 05 78.</p>
                </div>
            </div>
        </>
    );
}